import PrivateRoute from '@/components/private-route.component';
import { AuthPartnerSelectPage } from '@/modules/auth/pages/auth-partner-select.page.tsx';
import { ExternalItemsPage } from '@/modules/external/pages/items/external-items.page.tsx';
import { ExternalOverviewPage } from '@/modules/external/pages/overview/external-overview.page.tsx';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ExternalLayout } from './components/external.layout';
import { ExternalCartAddressesPage } from './pages/cart/external-cart-addresses.page';
import { ExternalCartCompletedPage } from './pages/cart/external-cart-completed.page';
import { ExternalCartConfirmPage } from './pages/cart/external-cart-confirm.page';
import { ExternalCartOverviewPage } from './pages/cart/external-cart-overview.page';
import ExternalCtoPage from './pages/cto/external-cto.page';
import ExternalOrderDetailsPage from './pages/orders/external-order-details.page';
import ExternalOrdersPage from './pages/orders/external-orders.page';
import { ErrorPage } from '@/components/error.page';
import { NotFoundErrorPage } from '@/components/not-found-error.page';
import { SettingsLayout } from './pages/settings/settings.layout';
import { SettingsProfilePage } from './pages/settings/settings-profile.page';
import { SettingsAddressesPage } from './pages/settings/settings-addresses.page';
import { SettingsShippingPage } from './pages/settings/settings-shipping.page';

const ExternalRouter = () => (
  <Routes>
    <Route element={<PrivateRoute />}>
      <Route index element={<AuthPartnerSelectPage />} />
      <Route element={<ExternalLayout />} errorElement={<ErrorPage />}>
        <Route path="c">
          <Route index element={<ExternalOverviewPage />} />
          <Route path="items" element={<ExternalItemsPage />} />
          <Route path="cto" element={<ExternalCtoPage />} />
          <Route path="settings" element={<SettingsLayout />}>
            <Route index element={<Navigate to="profile" replace />} />
            <Route path="profile" element={<SettingsProfilePage />} />
            <Route path="addresses" element={<SettingsAddressesPage />} />
            <Route path="shipping" element={<SettingsShippingPage />} />
          </Route>
          <Route
            path="account"
            element={<Navigate to="/bp/c/settings/profile" replace />}
          />
          <Route path="orders">
            <Route index element={<ExternalOrdersPage />} />
            <Route path=":orderId" element={<ExternalOrderDetailsPage />} />
          </Route>
          <Route path="cart">
            <Route index element={<ExternalCartOverviewPage />} />
            <Route path="2" element={<ExternalCartAddressesPage />} />
            <Route path="3" element={<ExternalCartConfirmPage />} />
            <Route path="4/:orderId" element={<ExternalCartCompletedPage />} />
          </Route>
        </Route>

        {/* 404 catch-all (inside layout) */}
        <Route path="*" element={<NotFoundErrorPage />} />
      </Route>
    </Route>
  </Routes>
);

export default ExternalRouter;
